// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"493":"flipbook-old","897":"flipbook","962":"home"}[chunkId] || chunkId) + "." + {"194":"dfbbf0de","493":"120af168","511":"05ec3b8d","684":"d2a9af45","712":"9e31006d","897":"a98d6d9f","918":"46ae2492","962":"3b9ab398"}[chunkId] + ".js";
};